/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';
import { DesignerCard_UserFragment } from './DesignerCard.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InviteDesignersPageQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type InviteDesignersPageQuery = {
    __typename: 'Query';
    brief: { __typename: 'StructuredBrief' } & InviteDesignersPage_StructuredBriefFragment;
};

export type RelevantDesignersQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
    size: Types.Scalars['Int'];
    offset: Types.Scalars['Int'];
}>;

export type RelevantDesignersQuery = {
    __typename: 'Query';
    designers: {
        __typename: 'RelevantDesignersResponse';
        total: number;
        nextOffset: number;
        hits: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
    };
};

export type InviteDesignersPage_StructuredBriefFragment = {
    __typename: 'StructuredBrief';
    id: string;
    language: string;
    designers: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
};

export const InviteDesignersPage_StructuredBriefFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InviteDesignersPage_StructuredBrief' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StructuredBrief' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designers' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'DesignerCard_User' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerCard_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignerMeta_User' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageSources' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'original',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mediaCrop',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerMeta_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'penaltyState' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'utcOffset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastSeenAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locales' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'categories' },
                                    name: { kind: 'Name', value: 'categoriesWithValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const InviteDesignersPageDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'InviteDesignersPage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'structuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'InviteDesignersPage_StructuredBrief',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InviteDesignersPage_StructuredBrief' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StructuredBrief' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designers' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'DesignerCard_User' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerCard_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignerMeta_User' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageSources' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'original',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mediaCrop',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerMeta_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'penaltyState' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'utcOffset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastSeenAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locales' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'categories' },
                                    name: { kind: 'Name', value: 'categoriesWithValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type InviteDesignersPageComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        InviteDesignersPageQuery,
        InviteDesignersPageQueryVariables
    >,
    'query'
> &
    ({ variables: InviteDesignersPageQueryVariables; skip?: boolean } | { skip: boolean });

export const InviteDesignersPageComponent = (props: InviteDesignersPageComponentProps) => (
    <ApolloReactComponents.Query<InviteDesignersPageQuery, InviteDesignersPageQueryVariables>
        query={InviteDesignersPageDocument}
        {...props}
    />
);

/**
 * __useInviteDesignersPageQuery__
 *
 * To run a query within a React component, call `useInviteDesignersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteDesignersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteDesignersPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteDesignersPageQuery(
    baseOptions: Apollo.QueryHookOptions<
        InviteDesignersPageQuery,
        InviteDesignersPageQueryVariables
    >
) {
    return Apollo.useQuery<InviteDesignersPageQuery, InviteDesignersPageQueryVariables>(
        InviteDesignersPageDocument,
        baseOptions
    );
}
export function useInviteDesignersPageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        InviteDesignersPageQuery,
        InviteDesignersPageQueryVariables
    >
) {
    return Apollo.useLazyQuery<InviteDesignersPageQuery, InviteDesignersPageQueryVariables>(
        InviteDesignersPageDocument,
        baseOptions
    );
}
export type InviteDesignersPageQueryHookResult = ReturnType<typeof useInviteDesignersPageQuery>;
export type InviteDesignersPageLazyQueryHookResult = ReturnType<
    typeof useInviteDesignersPageLazyQuery
>;
export type InviteDesignersPageQueryResult = Apollo.QueryResult<
    InviteDesignersPageQuery,
    InviteDesignersPageQueryVariables
>;
export const RelevantDesignersDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'RelevantDesigners' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'designers' },
                        name: { kind: 'Name', value: 'relevantDesigners' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'size' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'offset' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hits' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'DesignerCard_User' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextOffset' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerCard_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignerMeta_User' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageSources' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'original',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mediaCrop',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerMeta_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'penaltyState' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'utcOffset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastSeenAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locales' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'categories' },
                                    name: { kind: 'Name', value: 'categoriesWithValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type RelevantDesignersComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        RelevantDesignersQuery,
        RelevantDesignersQueryVariables
    >,
    'query'
> &
    ({ variables: RelevantDesignersQueryVariables; skip?: boolean } | { skip: boolean });

export const RelevantDesignersComponent = (props: RelevantDesignersComponentProps) => (
    <ApolloReactComponents.Query<RelevantDesignersQuery, RelevantDesignersQueryVariables>
        query={RelevantDesignersDocument}
        {...props}
    />
);

/**
 * __useRelevantDesignersQuery__
 *
 * To run a query within a React component, call `useRelevantDesignersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelevantDesignersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelevantDesignersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRelevantDesignersQuery(
    baseOptions: Apollo.QueryHookOptions<RelevantDesignersQuery, RelevantDesignersQueryVariables>
) {
    return Apollo.useQuery<RelevantDesignersQuery, RelevantDesignersQueryVariables>(
        RelevantDesignersDocument,
        baseOptions
    );
}
export function useRelevantDesignersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        RelevantDesignersQuery,
        RelevantDesignersQueryVariables
    >
) {
    return Apollo.useLazyQuery<RelevantDesignersQuery, RelevantDesignersQueryVariables>(
        RelevantDesignersDocument,
        baseOptions
    );
}
export type RelevantDesignersQueryHookResult = ReturnType<typeof useRelevantDesignersQuery>;
export type RelevantDesignersLazyQueryHookResult = ReturnType<typeof useRelevantDesignersLazyQuery>;
export type RelevantDesignersQueryResult = Apollo.QueryResult<
    RelevantDesignersQuery,
    RelevantDesignersQueryVariables
>;
